import type { ReactElement } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { CONTACTS_PER_COMPANY_LIMIT_TRANSLATIONS } from "app/pages/sales-intelligence/common-components/contacts-per-company-limit-input/constants";
import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindContactLimitResultsFilter from "../../../models/ContactLimitResultsFilter/ContactLimitResultsFilter";

const ContactLimitResultsFilterResult = ({
    value,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<FindContactLimitResultsFilter>): ReactElement | null => {
    if (!value) {
        return null;
    }

    const text = `${value.contactsCount} ${translate(CONTACTS_PER_COMPANY_LIMIT_TRANSLATIONS.suffix)}`;

    return (
        <Flex>
            <FiltersChip
                text={text}
                hideActionButton={!isActionEnabled}
                chipStatus={onGetLifecycleStatus?.(value.contactsCount)}
                onClose={() => {
                    onFilterValueRemove?.();
                    onFilterUpdate();
                }}
            />
        </Flex>
    );
};

export default ContactLimitResultsFilterResult;
